import { API_ENDPOINT } from './config';

export const urlsWiki = {
  wikiPages: `${API_ENDPOINT}/wiki-pages`,
  wikiPageDetail: (slug) => `${API_ENDPOINT}/wiki-pages/${slug}`,

  wikiCategories: `${API_ENDPOINT}/wiki-categories`,
  wikiCategoryDetail: (id) => `${API_ENDPOINT}/wiki-categories/${id}`,

  fileUpload: `${API_ENDPOINT}/upload/upload-file`,
};

export const routesWiki = {
  cmsWikiPages: '/cms/wiki-pages',
  cmsWikiPageCreate: '/cms/wiki-pages/create',
  cmsWikiPagePreview: '/cms/wiki-pages/preview',
  cmsWikiPageEdit: '/cms/wiki-pages/edit',
  cmsWikiPageDetail: '/cms/wiki-pages/detail',

  cmsWikiCategories: '/cms/wiki-categories',
  cmsWikiCategoryCreate: '/cms/wiki-categories/create',
  cmsWikiCategoryEdit: '/cms/wiki-categories/edit',
};
